import { useState } from 'react';
import { COLORS } from '../lib/colors';
import EbookModal from '../components/EbookModal';

// Cuatro guías descargables. Hardcode intencional (sin tabla `ebooks` en BD):
// mismas keys, mismo EbookModal, mismo POST /api/ebook.php de siempre.
// Los pesos son literales medidos por HEAD; si se comprimen los PDFs, actualizar aquí.
const EBOOKS = [
  { key: "trascender", title: "Las empresas familiares buscan trascender generaciones", size: "3.8 MB" },
  { key: "gobierno",   title: "Gobierno Corporativo para Empresas Familiares 4.0",        size: "5.5 MB" },
  { key: "propiedad",  title: "Governance: Una Revisión desde la Esfera de la Propiedad", size: "27.3 MB" },
  { key: "gobernanza", title: "La Nueva Era de las Empresas Familiares: Governanza e Innovación.", size: "21.8 MB" },
];

// Biblioteca de ebooks. No existe en la referencia; usa su misma gramática que
// #valores —numeración en Space Mono, separadores hairline de 1px, sin cajas ni
// sombras— y cabecera centrada con filete, como las demás secciones.
export default function EbooksSection() {
  const [activeEbook, setActiveEbook] = useState(null);

  return (
    <>
      <section style={{ padding: "clamp(64px, 12vw, 160px) clamp(20px, 8vw, 128px)", background: COLORS.cream }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 112 }}>
            <p style={{ fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 400, letterSpacing: "2.2px", textTransform: "uppercase", color: COLORS.goldText, margin: "0 0 24px" }}>
              Recursos descargables
            </p>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(30px, 5vw, 52px)", fontWeight: 400, letterSpacing: "-0.01em", color: COLORS.text, lineHeight: 1.1, margin: "0 0 24px" }}>
              Guías para llevar al consejo
            </h2>
            <div style={{ width: 48, height: 1, background: COLORS.goldText, margin: "0 auto 24px" }} />
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 400, lineHeight: 1.8, color: COLORS.textLight, maxWidth: 560, margin: "0 auto" }}>
              Documentos de trabajo sobre gobierno corporativo, sucesión y continuidad familiar.
            </p>
          </div>

          <div className="todd-ebooks-grid">
            {EBOOKS.map((e, i) => (
              <div key={e.key} className="ebook-card">
                <p style={{
                  fontFamily: "'Space Mono', monospace", fontSize: 11, fontWeight: 400,
                  letterSpacing: "1.65px", color: COLORS.goldText, margin: "0 0 32px",
                }}>
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="ebook-title" style={{
                  fontFamily: "'Playfair Display', serif", fontSize: "clamp(20px, 2.5vw, 24px)",
                  fontWeight: 400, color: COLORS.text, margin: "0 0 16px", lineHeight: 1.3,
                }}>
                  {e.title}
                </h3>
                <div className="ebook-underline" style={{ width: 32, height: 1, background: "rgba(140, 102, 52, 0.3)", marginBottom: 16 }} />
                {e.size && (
                  <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, lineHeight: 1.8, color: COLORS.textLight, margin: "0 0 28px" }}>
                    PDF · {e.size}
                  </p>
                )}
                <button
                  onClick={() => setActiveEbook(e)}
                  aria-label={`Recibir ebook: ${e.title}`}
                  style={{
                    marginTop: "auto", alignSelf: "flex-start", whiteSpace: "nowrap",
                    fontFamily: "'Inter', sans-serif", fontSize: 12, fontWeight: 500,
                    letterSpacing: "1.2px", textTransform: "uppercase", lineHeight: "44px",
                    color: COLORS.goldText, background: "transparent",
                    border: `1px solid ${COLORS.goldText}66`, padding: "0 32px",
                    cursor: "pointer", transition: "background 0.3s, color 0.3s",
                  }}
                  onMouseEnter={ev => { ev.currentTarget.style.background = COLORS.goldText; ev.currentTarget.style.color = COLORS.cream; }}
                  onMouseLeave={ev => { ev.currentTarget.style.background = "transparent"; ev.currentTarget.style.color = COLORS.goldText; }}
                >
                  Recibir ebook
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {activeEbook && <EbookModal ebook={activeEbook} onClose={() => setActiveEbook(null)} />}
    </>
  );
}
